interface IFilterValues {
  type?: string;
  status?: string;
  [key: string]: any;
}

const generateFilter = (values: IFilterValues): string => {
  if (!values) {
    return "";
  }
  const filtered = Object.entries(values).filter((el) => !!el[1]);

  return filtered.map((el) => `${el[0]}=${el[1]}`).join(",");
};

export default generateFilter;
